
export default {
  title: 'Tablero'
}
